<!-- Navigation-->
<nav class="navbar navbar-expand-lg navbar-light fixed-top py-3" id="mainNav">
    <div class="container">
        <a class="navbar-brand js-scroll-trigger" routerLink="/home"><span>CMD Truck</span><img src='../../assets/images/logo.png' style="display: none;"/></a>
        <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav ml-auto my-2 my-lg-0">
                <li class="nav-item"><a class="nav-link js-scroll-trigger" routerLink="/home">Home</a></li>
                <li class="nav-item"><a class="nav-link js-scroll-trigger" routerLink="/about">Despre noi</a></li>
                <li class="nav-item"><a class="nav-link js-scroll-trigger" routerLink="/team">Echipa noastră</a></li>
                <li class="nav-item" [hidden]="1"><a class="nav-link js-scroll-trigger" routerLink="/calculator">Calculator</a></li>
                <li class="nav-item"><a class="nav-link js-scroll-trigger" routerLink="/contact">Contact</a></li>
            </ul>
        </div>
    </div>
</nav>